import { Skeleton } from 'antd';

const Loading: React.FC = () => (
  <Skeleton
    style={{
      margin: 'var(--content-spacing-xl) var(--content-spacing-xl)',
      height: '60vh',
    }}
    active
  />
);

export default Loading;
